<div class="pIndex-con">
    <div class="clearfix">
       <ul class="pIndex-nav">
            <li class="active">关注</li>
            <li>粉丝</li>
            <li>访客
                <span class="badge"><img src="../../../public/images/tab_vip_ico.png"></span>
            </li>
            <li>黑名单</li>
        </ul>
        <span class="fr" id="visitor-label" style="font-size:14px;color: #FF5379;display:none;">本周访客{{visitorCount}}人</span>
    </div>

    <div class="pIndex-content">
        <div class="pIndex-content-item active" id="attentionList"></div>
        <div class="pIndex-content-item" id="followList"></div>
        <div class="pIndex-content-item" id="visitList">
            {{if IsVIP!=1}}
                <p>VIP用户拥有该权限，请开通VIP再查看</P>
            {{/if}}
        </div>
        <div class="pIndex-content-item" id="blackList"></div>
    </div>
</div>

